export const white = '#fff';
export const black = '#000';
export const utility = '#0095E8';
//export const red = '#ac0000';
export const errorRed = '#f00';
export const red = '#db2828';
export const green = '#009e0f';
export const yellow = '#fbcc08';

export const productStates = {
  sold: green,
  noSale: red,
  subjectTo: yellow,
  open: utility,
  pulled: black,
  none: white,
};
